import { render } from "./requestingClients.vue?vue&type=template&id=525ace82"
import script from "./requestingClients.vue?vue&type=script&lang=js"
export * from "./requestingClients.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__